// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"529d09b4","453":"68693753"}[chunkId] + ".chunk.js";
};